
    <div>
      <canvas baseChart
        [datasets]="barChartData"
        [labels]="barChartLabels"
        [options]="barChartOptions"
        [legend]="barChartLegend"
        [type]="barChartType">
      </canvas>
    </div>
    <!-- <button mat-button mat-raised-button color="primary" (click)="randomize()">Update</button>
   -->
<!-- [
  ]="barChartPlugins" -->